import { connect } from 'react-redux';
import {
    changeStocksFilters,
    changePeriod,
    changeRegion,
    fetchStocks,
    loadingStocks,
    newStocks,
    updateStock,
} from '../../actions/stocks';
import { feedColumns } from '../../service/tickercolumns';
import { getRegions } from '../../service/stocks';
import { getSourceByFilters } from '../../service/stocks';
import withTableSubscription from '../../hoc/withTableSubscription';
import withPageTitle from '../../hoc/withPageTitle';
import StocksPage from '../../components/pages/StocksPage';

function mapStateToProps({ stocks }, params) {
    const { symbols, filters, isFetching } = stocks;
    const { region, market, list } = params;
    const state = {
        title: 'Aktier',
        regions: getRegions(),
        symbols,
        filters,
        sources: null,
        columns: feedColumns,
        isFetching,
    };

    if (region && typeof region !== 'undefined') {
        state.filters.region = region;
    }

    if (market && typeof market !== 'undefined') {
        state.filters.market = market;
    }

    if (list && typeof list !== 'undefined') {
        state.filters.list = list;
    }

    state.sources = getSourceByFilters(
        state.filters.region,
        state.filters.market,
        state.filters.list
    );

    return state;
}

const mapDispatchToProps = {
    changeFilters: changeStocksFilters,
    changePeriod,
    changeRegion,
    create: newStocks,
    fetch: fetchStocks,
    update: updateStock,
    loadingStocks,
};

export default connect(mapStateToProps, mapDispatchToProps)(
    withTableSubscription(withPageTitle(StocksPage))
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/pages/StocksPage.js
 **/